import { createSlice, nanoid } from '@reduxjs/toolkit';
import { SNACKBAR_DURATION } from 'Douleutaras/configuration/snackbar';
import { JSX } from 'react';

/*
  // Usage to create a snackbar notification:

  dispatch(
    addSnackbarNotification({
      duration: 2000, // in ms
      type: SnackbarNotificationType.INFO,
      message: 'Hello, I am a snackbar!',
      dismissible: true // USer can dismiss the snackbar
      offset: '100px' // offset from the bottom of the screen if need
    })
  )
 */

export enum SnackbarNotificationType {
  WARNING,
  ERROR,
  SUCCESS,
  INFO
}

export interface SnackbarNotification {
  id: string; // set automatically
  duration: number;
  type: SnackbarNotificationType;
  message: string | JSX.Element;
  dismissible: boolean;
  dismissed?: boolean; // set automatically
  title?: string;
  offset?: string;
}

export const snackbarSlice = createSlice(
  {
    name: 'snackbar',
    initialState: [] as Array<SnackbarNotification>,
    reducers: {
      // Use this action to create new notification
      addSnackbarNotification: (state, action) => {
        // Generate a random id so we can refer and dismiss this notification, unless id is provided
        if (action.payload.id === undefined) {
          action.payload.id = nanoid();
          action.payload.dismissed = false;
        }
        if (action.payload.duration === undefined) {
          action.payload.duration = SNACKBAR_DURATION;
        }
        state.push(action.payload);
      },

      setSnackbarNotificationAsDismissed: (state, action) => {
        const id = action.payload.id;
        const index = state.findIndex(item => item.id === id);
        state[index].dismissed = true;
      },

      // Dismiss is triggered automatically in most cases. However, can be done manually also if you input an id
      // during addSnackbarNotification.
      dismissSnackbarNotification: (state, action) => {
        const id = action.payload.id;

        return state.filter(notification => notification.id !== id);
      }
    },
    extraReducers: {}
  }
);

export default snackbarSlice;
export const { addSnackbarNotification, setSnackbarNotificationAsDismissed, dismissSnackbarNotification } = snackbarSlice.actions;
